import type { OperationalAvailability } from './api';

export type OperationalStatusPresentation = {
  state: 'online' | 'working' | 'unavailable';
  label: string;
  detail: string;
};

export function tenantOperationalStatus(availability: OperationalAvailability | null): OperationalStatusPresentation {
  if (!availability) {
    return { state: 'unavailable', label: 'Checking Inference Node', detail: 'Checking processing availability.' };
  }

  const state = availability.inference_node_state ?? (availability.inference_node_online ? 'online' : 'unavailable');
  if (state === 'working') {
    return { state, label: 'Inference Node working', detail: 'Processing capacity is active.' };
  }
  if (state === 'online') {
    return { state, label: 'Inference Node online', detail: 'Processing capacity is available.' };
  }
  return { state, label: 'Inference Node unavailable', detail: 'Processing capacity is temporarily unavailable.' };
}
